import { useNavigate } from "react-router-dom";
import { UIBox } from "../../_core/components";
import UIAlert from "../../_core/components/ui/UIAlert";
import UIButton from "../../_core/components/ui/UIButton";
import UICard from "../../_core/components/ui/UICard";

interface StatusMessageProps {
  type: "success" | "error";
  message: string;
  onConfirm?: () => void;
}

const StatusMessage = ({ type, message, onConfirm }: StatusMessageProps) => {
  const navigate = useNavigate();

  const handleConfirm = onConfirm ?? (() => navigate("/login"));

  return (
    <UICard sx={{ borderRadius: 0, boxShadow: "none" }}>
      <UIBox component="div" display="flex" flexDirection="column" alignItems="stretch" gap="1rem">
        <UIAlert variant="filled" severity={type}>
          {message}
        </UIAlert>
        <UIButton onClick={handleConfirm}>Go to login page</UIButton>
      </UIBox>
    </UICard>
  );
};

export default StatusMessage;
